<template>
    <div>
        <div class="card-body">
            <p class="text-center aboutscroll">
                <i class="fas fa-hourglass-half"></i>&nbsp;Waiting for buyer to release funds.
            </p>
            <p class="text-center aboutscroll">
                Please check &nbsp;<span class="text-info"><i class="ti-truck"></i>&nbsp;Shipments</span> tab to track your shipments.
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Open",
        props: ['trade_status']
    }
</script>

<style scoped>

</style>